export default "__VITE_ASSET__ySEedJTp__"